import whenDomReady from 'when-dom-ready';

import { Alert, Collapse } from 'bootstrap';

import { jsReady } from './util/jsReady';
import { initMap } from './map/init';

whenDomReady(() => {
    jsReady();

    const alertEls = [].slice.call(document.querySelectorAll('.alert'));

    alertEls.map(function (alertEl) {
        return new Alert(alertEl);
    });

    const collapsiblEls = [].slice.call(document.querySelectorAll('.collapse'));

    collapsiblEls.map(function (collapseEl) {
        return new Collapse(collapseEl, { toggle: false });
    });

    if (document.getElementById('map')) initMap();
});
